export default class AdvantageModel {
    constructor({id, name, description, icon, language, is_active, created_by, created_by_name}) {
        this.id = id;
        this.name = name;
        this.deskripsi = description;
        this.icon = icon;
        this.language = language;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
    }
}